import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

import { Toast } from "@/app/storefront/Toast";

export function Providers({ children }: { children: React.ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { refetchOnWindowFocus: false },
        },
      }),
  );

  return (
    <QueryClientProvider client={client}>
      {children}
      <Toast />
    </QueryClientProvider>
  );
}
